var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpsz242(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #7f84f6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,17.8l-.7-.7,6.7-6.7,4,4,3.6-4.1c-1-1.2-2.1-2.1-3.4-2.7-1.3-.7-2.6-1-4.1-1s-2.3.2-3.3.6c-1,.4-2,1-2.9,1.7l-.7-.7c1-.8,2-1.4,3.2-1.9,1.2-.5,2.4-.7,3.7-.7s3,.3,4.4,1c1.4.7,2.6,1.7,3.7,2.9l2.9-3.3.7.7-3,3.4c.5.8,1,1.7,1.4,2.7.4,1,.6,2,.8,3h-1c-.1-.8-.3-1.6-.6-2.4-.3-.8-.7-1.7-1.2-2.5l-4.2,4.6-4-4s-6,6-6,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpsz242);
export default __webpack_public_path__ + "static/media/opsz24-2.59efd774a6cc9981cb82b13b2c0be0b3.svg";
export { ForwardRef as ReactComponent };